import { useParams, Link } from "react-router-dom";
import { Reveal } from "@/components/Motion";

const PAGES = {
  "privacy-policy": {
    title: "Privacy Policy",
    sections: [
      ["Overview", "Regal Tuning Ltd respects your privacy. This policy explains what personal data we collect when you use our website, shop and contact forms, and how we use it."],
      ["Data we collect", "Contact details you submit (name, email, telephone, company, country), order and enquiry information, and standard technical data such as IP address and browser type."],
      ["How we use it", "To respond to enquiries, process and deliver orders, manage dealer applications, and improve our website. We do not sell your data to third parties."],
      ["Your rights", "You may request access, correction or deletion of your personal data at any time by contacting info@regaltuning.com."],
    ],
  },
  "terms-and-conditions": {
    title: "Terms & Conditions",
    sections: [
      ["Supply of goods", "All tuning tools and equipment are supplied for professional use. Prices are shown in the currency stated at checkout. Orders are subject to acceptance and stock availability."],
      ["Tuning files", "ECU calibration files are supplied through the Regal Tuning File Portal to approved account holders under separate trade terms."],
      ["Liability", "Calibrations may be intended for motorsport or off-road use where stated. It is the installer's responsibility to verify vehicle condition and local legal requirements."],
      ["Governing law", "These terms are governed by the laws of the United Arab Emirates."],
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    sections: [
      ["What we use", "This website uses a small number of cookies and browser storage to operate the shopping cart and remember preferences."],
      ["Analytics", "We may use privacy-respecting analytics to understand aggregate website usage. No advertising trackers are used."],
      ["Control", "You can clear or block cookies at any time through your browser settings."],
    ],
  },
  "returns-policy": {
    title: "Returns Policy",
    sections: [
      ["Hardware", "Unused hardware in original packaging may be returned within 14 days of delivery. Activated software, protocol packages and subscriptions are non-returnable once activated."],
      ["Faulty goods", "Faulty equipment is covered by the manufacturer's warranty and will be repaired or replaced. Contact our technical desk before returning any item."],
      ["Process", "Email info@regaltuning.com with your order reference to arrange a return authorisation before sending goods back."],
    ],
  },
  "delivery-information": {
    title: "Delivery Information",
    sections: [
      ["Dispatch", "Stocked items are dispatched within 1–2 working days. Used and ex-demo equipment is tested before dispatch."],
      ["Worldwide shipping", "We ship worldwide using tracked and insured couriers. Delivery estimates are confirmed at order time."],
      ["Duties", "International customers are responsible for any import duties or taxes applied by their country."],
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const content = PAGES[page];
  if (!content) {
    return (
      <main className="grid min-h-[60vh] place-items-center pt-24">
        <Link to="/" className="text-regal-amber underline">Return home</Link>
      </main>
    );
  }
  return (
    <main data-testid={`legal-${page}`} className="pt-36 pb-24 sm:pt-44">
      <div className="container-regal max-w-3xl">
        <p className="overline-label mb-4">Legal</p>
        <h1 className="font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight">{content.title}</h1>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-neutral-500">Last updated: July 2026</p>
        <div className="mt-12 space-y-10">
          {content.sections.map(([h, body], i) => (
            <Reveal key={h} delay={i * 0.04}>
              <section>
                <h2 className="font-display text-xl font-bold uppercase tracking-wide text-neutral-100">{h}</h2>
                <p className="mt-3 text-sm sm:text-base leading-relaxed text-neutral-400">{body}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
